<div class="layout-time-container scrollable-component-container">
  <div class="attribute-editor-component">
    <div class="attribute-editor-row">
      <!-- Time Format Selection -->
      <div class="form-group">
        <label>Time Format</label>
        <mat-button-toggle-group
          [(ngModel)]="timeFormat"
          (ngModelChange)="setTimeFormat($event)"
          hideSingleSelectionIndicator="true"
        >
          <mat-button-toggle value="Hours12">12h</mat-button-toggle>
          <mat-button-toggle value="Hours24">24h</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>

    <div class="attribute-editor-row">
      <div class="form-group">
        <label>Time Zone</label>
        <select
          id="te-lt-timezone"
          class="form-control"
          [(ngModel)]="timezone"
          (change)="save()"
        >
          <option value="">Display's Time Zone (Default)</option>
          @for (tz of WORLD_TIMEZONES; track tz) {
            <option [value]="tz">{{ tz }}</option>
          }
        </select>
      </div>
    </div>

    <div class="attribute-editor-row">
      <!-- Color Picker -->
      <div class="form-group">
        <label>Color</label>
        <div class="flex-row left-right-aligner">
          <color-picker
            pickerId="te-lt-color"
            [(ngModel)]="color"
            (change)="save()"
            ngDefaultControl
          ></color-picker>
        </div>
      </div>
    </div>
  </div>
</div>
